module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-map"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-button"
  }, [_c('user-bar')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n\n        Map Name:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Map name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n\n        Thumbnail:\n        "), _c('dropzone', {
    staticClass: "thumbnailDropzone",
    attrs: {
      "id": "thumbnailDropzone",
      "options": {
        url: 'https://api.graph.cool/file/v1/cj59tz3nfrlhy0105885qy550',
        paramName: 'data',
        useFontAwesome: true,
        maxNumberOfFiles: 1,
      }
    },
    on: {
      "vdropzone-success": _vm.thumbnailSuccess
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n\n        Map:\n        "), _c('dropzone', {
    ref: "mapDropzone",
    staticClass: "mapDropzone",
    attrs: {
      "id": "mapDropzone",
      "options": {
        autoQueue: false,
        url: 'https://api.graph.cool/file/v1/cj59tz3nfrlhy0105885qy550',
        paramName: 'data',
        useFontAwesome: true,
        maxNumberOfFiles: 1,
        resizeWidth: 1024,
        resizeHeight: 1024,
        resizeQuality: 1.0,
        resizeMethod: 'contain'
      }
    },
    on: {
      "vdropzone-success": _vm.minimapSuccess,
      "vdropzone-processing": _vm.handleProcessing,
      "vdropzone-file-added": _vm.handleFileAdded
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.incompleteError),
      expression: "incompleteError"
    }],
    staticClass: "row"
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.existError),
      expression: "existError"
    }],
    staticClass: "row"
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "submit"
  }, [(_vm.user) ? _c('button', {
    staticClass: "submit__button",
    on: {
      "click": _vm.handleCreateMap
    }
  }, [_vm._v("\n          Create map\n        ")]) : _c('button', {
    staticClass: "submit__button",
    on: {
      "click": _vm.showLock
    }
  }, [_vm._v("\n          Signin first\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("\n        Add a new map\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "background-color": "#e74c3c"
    }
  }, [_c('b', [_vm._v("Warning: ")]), _vm._v(" Please enter all the fields!\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "background-color": "#e74c3c"
    }
  }, [_c('b', [_vm._v("Warning: ")]), _vm._v(" This map already exists!\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e60d8bda","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/MapSelection/Add/index.vue
// module id = 729
// module chunks = 1